import React from 'react';
import ProjectManager from 'templates/careers/technicalProjectManager';

const TechnicalProjectManager = () => (
  <ProjectManager />
);

export default TechnicalProjectManager;
